<footer class="givaudan-footer">
  <div class="footer__content">
    <section class="footer-section footer-title">
      <h2 class="heading-s">{{ 'footer.logo.givaudan' | translate }}</h2>
      <span class="footer-row body-l-bold">
        {{ 'footer.title.follow-us-on' | translate }}
        <a
          class="linkedin-logo footer-row"
          href="{{ LINKEDIN_LINK }}"
          aria-label="Givaudan LinkedIn"
          target="_blank">
          <app-icon [svgIcon]="'linkedin'" [class]="'linkedin-logo-dimension'"></app-icon>
        </a>
      </span>
    </section>
    <section class="line-separator"></section>
    <section class="footer-section footer-links">
      <span class="body-l">
        {{ 'footer.content' | translate }}
      </span>
      <div class="footer-block-links">
        <h3 class="footer-block-links__title heading-xs">
          {{ 'footer.title.company' | translate }}
        </h3>
        <ul class="footer-block-links__list">
          @for (link of companyLinks; track link) {
            <li>
              @if (link.name === 'global-privacy-notice') {
                <a [href]="link.href" target="_blank">{{ 'simple-link-names.company.' + link.name | translate }}</a>
              } @else {
                <a [routerLink]="['/', link.href]">{{ 'simple-link-names.company.' + link.name | translate }}</a>
              }
            </li>
          }
        </ul>
      </div>
      <div class="footer-block-links">
        <h3 class="footer-block-links__title heading-xs">
          {{ 'footer.title.fragrances' | translate }}
        </h3>
        <ul class="footer-block-links__list">
          @for (link of fragrancesLinks; track link) {
            <li>
              <a [routerLink]="['/edito/', link.href]">{{ 'simple-link-names.fragrances.' + link.name | translate }}</a>
            </li>
          }
        </ul>
      </div>
      <div class="footer-block-links">
        <h3 class="footer-block-links__title heading-xs">
          {{ 'footer.title.support' | translate }}
        </h3>
        <ul class="footer-block-links__list">
          @for (link of supportLinks; track link) {
            <li>
              <a [routerLink]="['/', link.href]">{{ 'simple-link-names.support.' + link.name | translate }}</a>
            </li>
          }
        </ul>
      </div>
    </section>
  </div>
  <section class="footer-section footer-legals footer__bottom">
    <a
      class="linkedin-logo footer-row"
      href="{{ LINKEDIN_LINK }}"
      target="_blank">
      <app-icon [svgIcon]="'linkedin'" [class]="'linkedin-logo-dimension'"></app-icon>
    </a>

    <span class="body-s">
      © {{ 'footer.logo.givaudan' | translate }} {{ currentYear }}
    </span>
  </section>
</footer>
